import React, { MouseEvent, forwardRef, useCallback } from "react";

import { StyledNavBarButton } from "./Styles";
import { ArrowRightIcon } from "../Icons";
import ArrowLeftIcon from "../Icons/collection/ArrowLeft";

interface INavBarElementProps {
  onClick?: (e: MouseEvent) => void;
  onPreviousClick(callback?: () => void): void;
  onNextClick(callback?: () => void): void;
}

export const NavBarElement = forwardRef<HTMLDivElement, INavBarElementProps>(
  ({ onPreviousClick, onNextClick }, ref) => {
    const onPrevious = useCallback(() => {
      onPreviousClick();
    }, [onPreviousClick]);

    const onNext = useCallback(() => {
      onNextClick();
    }, [onNextClick]);

    return (
      <div className="c-DayPicker-NavBar" ref={ref} tabIndex={0}>
        <StyledNavBarButton
          type="button"
          variant="text gray"
          size="small"
          tabIndex={0}
          onClick={onPrevious}
          $direction="previous"
        >
          <ArrowLeftIcon aria-label="Previous Month" width="24" height="24" />
        </StyledNavBarButton>
        <StyledNavBarButton
          type="button"
          variant="text gray"
          size="small"
          tabIndex={0}
          onClick={onNext}
          $direction="next"
        >
          <ArrowRightIcon aria-label="Next Month" width="24" height="24" />
        </StyledNavBarButton>
      </div>
    );
  }
);

NavBarElement.displayName = "NavBarElement";
